import React, { Component } from "react";
import {
  Paper,
  withStyles,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import GetInfo from "../../../API/Companies/ShowAllAdmin";
import toasType from "../../../API/CallUtils/tostyNotification";
import Add from "./DialogAddAdmin";
import Delete from "../../../API/Companies/DeleteAdmin";
const styles = (theme) => ({
  Initial: {
    width: "100%",
  },
  Paper: {
    width: "100%",
    minHeight: "200px",
    borderRadius: "0px 0px 10px 10px",
    // padding: "1%",
    //marginTop: "1%",
  },
  Subtitle: {
    width: "100%",
    borderRadius: "10px 10px 0px 0px",
    backgroundColor: "#ad1d21",
    color: "rgb(247, 244, 244)",
    boxShadow:
      "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
  },
  AddCandidate: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(99, 159, 191,0.2)",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "rgb(30, 160, 230)",
    "&:hover": {
      backgroundColor: "rgb(99, 159, 191,0.5)",
    },
  },
  marginL: {
    marginLeft: "5px",
    width: "28%",
  },
  btn: {
    margin: "5px",
  },
});

class TablePadron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DialogEdit: false,
      RH: [],
      Gerencia: [],
      Produccion: [],
      type: "",
      title: "",
      Otro: [],
    };
  }
  componentDidMount = async () => {
    if (this.props.uuid) {
      this.GetInfo();
    }
  };
  Edit = (name, tit) => {
    this.setState({
      DialogEdit: !this.state.DialogEdit,
      type: name ? name : "",
    });
  };
  GetInfo = async () => {
    try {
      const SeccionsShow = await GetInfo(this.props.id);
      if (SeccionsShow) {
        console.log(SeccionsShow);
        const delgados = SeccionsShow.companyAdmins.filter(
          (member) => member.titleType === "RH"
        );
        const Comicionados = SeccionsShow.companyAdmins.filter(
          (member) => member.titleType === "Gerencia"
        );
        const Secretarios = SeccionsShow.companyAdmins.filter(
          (member) => member.titleType === "Produccion"
        );
        const otro = SeccionsShow.companyAdmins.filter(
          (member) => member.titleType === "Otro"
        );
        this.setState({
          RH: delgados,
          Gerencia: Comicionados,
          Produccion: Secretarios,
          Otro: otro,
        });
      } else {
        //toasType.error("Error en la petición al servidor");
        console.log(SeccionsShow);
      }
    } catch (e) {
      console.log(e);
      toasType.error("Error en la red / Error de conexión");
    }
  };
  reload = async () => {
    this.GetInfo();
    this.Edit();
  };
  Delete = async (uuid) => {
    try {
      const DeleteCommite = await Delete(uuid);
      if (DeleteCommite) {
        this.GetInfo();
        toasType.success("Elemento eliminado");
      } else {
        //toasType.error("Error en la petición al servidor");
        console.log(DeleteCommite);
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid className={classes.Initial}>
        <Grid container className={classes.Initial} spacing={1}>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.Initial}
          >
            <Typography
              align="Center"
              variant="h5"
              component="p"
              className={classes.Subtitle}
            >
              Gerencia
            </Typography>
            <Paper className={classes.Paper}>
              {this.state.Gerencia.length > 0 ? (
                <>
                  <Table
                    size="small"
                    aria-label="a dense table"
                    className={classes.TableCompany}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Teléfono</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Puesto</TableCell>
                        <TableCell>Borrar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.TableCompany}>
                      {this.state.Gerencia.map((Asesor) => {
                        return (
                          <React.Fragment>
                            <TableRow key={Asesor.Uuid}>
                              <TableCell component="th" scope="row">
                                {Asesor.fullName}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.phone}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.email}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Button
                                  color="secondary"
                                  onClick={this.Delete.bind(this, Asesor.id)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.btn}
                      onClick={this.Edit.bind(this, "Gerencia")}
                    >
                      <EditIcon />
                    </Button>
                  </Grid>
                </>
              ) : (
                <Button
                  className={classes.AddCandidate}
                  onClick={this.Edit.bind(this, "Gerencia")}
                >
                  Sin Miembros registrados
                </Button>
              )}
            </Paper>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.Initial}
          >
            <Typography
              align="Center"
              variant="h5"
              component="p"
              className={classes.Subtitle}
            >
              Recursos Humanos
            </Typography>
            <Paper className={classes.Paper}>
              {this.state.RH.length > 0 ? (
                <>
                  <Table
                    size="small"
                    aria-label="a dense table"
                    className={classes.TableCompany}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Teléfono</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Puesto</TableCell>
                        <TableCell>Borrar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.TableCompany}>
                      {this.state.RH.map((Asesor) => {
                        return (
                          <React.Fragment>
                            <TableRow key={Asesor.Uuid}>
                              <TableCell component="th" scope="row">
                                {Asesor.fullName}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.phone}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.email}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Button
                                  color="secondary"
                                  onClick={this.Delete.bind(this, Asesor.id)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                    className={classes.Margin}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.btn}
                      onClick={this.Edit.bind(this, "RH")}
                    >
                      <EditIcon />
                    </Button>
                  </Grid>
                </>
              ) : (
                <Button
                  className={classes.AddCandidate}
                  onClick={this.Edit.bind(this, "RH")}
                >
                  Sin Miembros registrados
                </Button>
              )}
            </Paper>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.Initial}
          >
            <Typography
              align="Center"
              variant="h5"
              component="p"
              className={classes.Subtitle}
            >
              Producción
            </Typography>
            <Paper className={classes.Paper}>
              {this.state.Produccion.length > 0 ? (
                <>
                  <Table
                    size="small"
                    aria-label="a dense table"
                    className={classes.TableCompany}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Teléfono</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Puesto</TableCell>
                        <TableCell>Borrar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.TableCompany}>
                      {this.state.Produccion.map((Asesor) => {
                        return (
                          <React.Fragment>
                            <TableRow key={Asesor.Uuid}>
                              <TableCell component="th" scope="row">
                                {Asesor.fullName}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.phone}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.email}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Button
                                  color="secondary"
                                  onClick={this.Delete.bind(this, Asesor.id)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.btn}
                      onClick={this.Edit.bind(this, "Produccion")}
                    >
                      <EditIcon />
                    </Button>
                  </Grid>
                </>
              ) : (
                <Button
                  className={classes.AddCandidate}
                  onClick={this.Edit.bind(this, "Produccion")}
                >
                  Sin Miembros registrados
                </Button>
              )}
            </Paper>
          </Grid>
          <Grid
            container
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.Initial}
          >
            <Typography
              align="Center"
              variant="h5"
              component="p"
              className={classes.Subtitle}
            >
              Sin clasificar
            </Typography>
            <Paper className={classes.Paper}>
              {this.state.Otro.length > 0 ? (
                <>
                  <Table
                    size="small"
                    aria-label="a dense table"
                    className={classes.TableCompany}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Teléfono</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Puesto</TableCell>
                        <TableCell>Borrar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.TableCompany}>
                      {this.state.Otro.map((Asesor) => {
                        return (
                          <React.Fragment>
                            <TableRow key={Asesor.Uuid}>
                              <TableCell component="th" scope="row">
                                {Asesor.fullName}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.phone}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.email}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {Asesor.title}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Button
                                  color="secondary"
                                  onClick={this.Delete.bind(this, Asesor.id)}
                                >
                                  <DeleteIcon />
                                </Button>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.btn}
                      onClick={this.Edit.bind(this, "Otro")}
                    >
                      <EditIcon />
                    </Button>
                  </Grid>
                </>
              ) : (
                <Button
                  className={classes.AddCandidate}
                  onClick={this.Edit.bind(this, "Otro")}
                >
                  Sin Miembros registrados
                </Button>
              )}
            </Paper>
          </Grid>
        </Grid>
        {this.state.DialogEdit
          ? [
              <Add
                CompanieUuid={this.props.uuid}
                id={this.props.id}
                DialogOpen={this.state.DialogEdit}
                DialogClose={this.Edit}
                type={this.state.type}
                Refresh={this.reload}
              />,
            ]
          : []}
      </Grid>
    );
  }
}

export default withStyles(styles)(TablePadron);
